import { useForceRerender } from '@/shared/lib/customHooks';

/**
 * Backs the event ECG strip slider with a manual redraw trigger. Returns the force-rerender callback obtained from the shared hook.
 *
 * @returns The force-rerender callback.
 */
export const useEcgSlider = () => {
  const forceRerender = useForceRerender();

  return { forceRerender };
};
